import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CountriesService } from '../countries.service';

@Component({
  selector: 'app-countries-list',
  templateUrl: './countries-list.component.html',
  styleUrls: ['./countries-list.component.scss'],
  providers: [ConfirmationService]
})
export class CountriesListComponent implements OnInit {

  @ViewChild("grid") public grid:Table;
  public countriesFilters:any = {};
  public countries:any[];
  public totalRecords:number;
  public loading:boolean = false;
  private lastGridEvent:any;

  constructor(private countriesService:CountriesService,    
    private router:Router,
    private confirmationService: ConfirmationService,
    private messageService:MessageService
    ) { }

  ngOnInit(): void {
  }

  search(){
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  clearFilters(){
    this.countriesFilters = {};
    this.search();
  }

  loadData($event){
    this.lastGridEvent = $event;
    Promise.resolve(null).then(() => this.loading = true);
    var params = {
      _page: $event.first,
      _pageSize: $event.rows,
      _sortBy: $event.sortField?$event.sortField:"",
      _sortDirection: $event.sortOrder>0?"asc":"desc"
    };
    params = Object.assign(params, this.countriesFilters);
    this.countriesService.all(params).subscribe(
      data => {
        this.totalRecords = data.totalRows;
        this.countries = data.rows;
        Promise.resolve(null).then(() => this.loading = false);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        Promise.resolve(null).then(() => this.loading = false);
      }
    );
  }

  edit(country){
    this.router.navigate(['/countries/', country.id ]);
  }

  delete(country){
    this.confirmationService.confirm({
      message: '¿Quieres borrar el país ' + country.name + '?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.countriesService.delete(country.id).subscribe(
          data => {
            this.loadData(this.lastGridEvent);
          },
          error => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        );
      },
      reject: () => {
        
      }
    });
  }
}
